import { axiosClient } from './axiosClient.service'

export function onNotAuthorized(cb: (error: unknown) => void) {
  axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const NOT_AUTHORIZED_STATUS = 401
      if (error.response.status === NOT_AUTHORIZED_STATUS) {
        cb(error)
      }

      return Promise.reject(error)
    },
  )
}
